import { Theme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import { Avatar } from "@mui/material";
import { parseFullName, parseInitials } from "../../../users/utils";
import UITypography from "./UITypography";
import { useAuthSession } from "../../../auth/hooks";

function UIAvatar({ textOnly = false }) {
  const classes = useStyles();
  const { data: session } = useAuthSession();

  if (textOnly) {
    return (
      <UITypography variant="subtitle2" className={classes.name}>
        {parseFullName(session?.userProfile)}
      </UITypography>
    );
  }
  return <Avatar className={classes.root}>{parseInitials(session?.userProfile)}</Avatar>;
}

const useStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    root: {},
    name: { fontWeight: "bold" },
  })
);

export default UIAvatar;
